module.exports = __webpack_public_path__ + "img/largada-esportiva-horizontal-negative-small.389031c1.svg";